function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__top-left">
                <div className="product-info__title title-def title-def_sec3">Пирогенный диоксид кремния</div>
              </div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/13.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <p>Пирогенный диоксид кремния - очень легкий микронизированный порошок с выраженными адсорбционными свойствами. Его получают взаимодействием газообразного четыреххлористого кремния с парами воды.</p>
              <p>Это ценный наполнитель для резин (особенно силиконовых). Кроме того, его применяют для приготовления различных смазок, красок и лаков, для стабилизации суспензий. Его загущающую способность используют при получении гелей для мазевых основ. Адсорбционные свойства используют с целью стабилизации сухих экстрактов (уменьшается их гигроскопичность). В порошках применяют при изготовлении гигроскопичных смесей и как диспергатор. В фармацевтической промышленности применяется в качестве антифрикционного (опудривающего) вещества. Также применяется в составе электролитов, как белая сажа.</p>
              <p></p>
              <h3>Сравнительная таблица:</h3>
                <img src={window.location.origin+"/img/info.webp"} alt=""/>
            </div>
            <div className="product-info__block">
              <div className="product-info__block-title title-def title-def_med">Немодифицированный Пирогенный диоксид кремния:</div>
              <div className="links-products">
                <div className="links-products__el">
                  <a target="_blank" href={window.location.origin+'/products/pyrogenic-silicon-dioxide/Rutesil-FS-150_rus.pdf'} download className="links-products-el links-products-el_2">
                    <div className="links-products-el__text">RUTESIL FS-150</div>
                  </a>
                </div>
                <div className="links-products__el">
                  <a target="_blank" href={window.location.origin+'/products/pyrogenic-silicon-dioxide/Rutesil-FS-200_rus.pdf'} download className="links-products-el links-products-el_2">
                    <div className="links-products-el__text">RUTESIL FS-200</div>
                  </a>
                </div>
                <div className="links-products__el">
                  <a target="_blank" href={window.location.origin+'/products/pyrogenic-silicon-dioxide/Rutesil-FS-300_rus.pdf'} download className="links-products-el links-products-el_2">
                    <div className="links-products-el__text">RUTESIL FS-300</div>
                  </a>
                </div>
                <div className="links-products__el">
                  <a target="_blank" href={window.location.origin+'/products/pyrogenic-silicon-dioxide/Rutesil-FS-380_rus.pdf'} download className="links-products-el links-products-el_2">
                    <div className="links-products-el__text">RUTESIL FS-380</div>
                  </a>
                </div>
              </div>
            </div>
            <div className="product-info__block">
              <div className="product-info__block-title title-def title-def_med">Модифицированный Пирогенный диоксид кремния:</div>
              <div className="links-products">
                <div className="links-products__el">
                  <a target="_blank" href={window.location.origin+'/products/pyrogenic-silicon-dioxide/Rutesil-FY-100_rus.pdf'} download className="links-products-el links-products-el_2">
                    <div className="links-products-el__text">RUTESIL FY-100</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;